import { Serializable } from "./serializable";
import { UtilitiesFunctions } from "@/helpers";
import { PriceData } from '@/models/experience';

// export interface Hours {
//   id: string;
//   name: string;
//   disabled?: boolean;
// }

export default class Reservation implements Serializable<Reservation> {
  aasmState?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  adults?: any | null;
  priceLabels: PriceData[] = [];
  priceExtras: PriceData[] = [];
  createdAt?: string;
  coupon?: string;
  duration?: number;
  email?: string;
  time?: string;
  id?: string | null;
  invoiceObject?: InvoiceForm;
  language?: any | null;
  message?: string;
  name?: string;
  price?: string;
  priceSymbol?: string;
  origin?: string;
  priceCurrency?: string;
  phone?: string;
  privacyBoolean?: boolean;
  priceLabel?: string;
  price2Label?: string;
  experience?: any;
  startAt?: string | null;
  surname?: string;
  timetable?: any;
  pricePerPerson?: number | null;
  total?: number;
  totalSymbol?: string;
  isGift?: boolean;
  giftId?: string;
  default_min_parties: number = 1;
  totalCurrency?: string;
  visitReason?: any;
  updatedAt?: string;
  experienceTypes?: any[];
  experienceId?: string;
  paypalData?: any;
  payAtTheWinery?: boolean;
  instantBooking: boolean;
  privacy_profiling?: boolean;
  privacy_marketing?: boolean;
  provider?: 'paypal' | 'stripe' | 'dwspay' | undefined;
  payment_intent_id?: string | null;
  optional_data: {
    birth_data: string,
    country: any
  }
  shippingAddress: {
    country: string,
    addressLine1: string,
    addressLine2: string,
    city: string,
    province: string,
    region: string,
    zipcode: string
  }

  localDeserialization(input: any): Reservation {
    if (input != null) {
      this.aasmState = input.aasmState || "";
      this.adults = input.adults || 0;
      this.priceLabels = input.priceLabels || [];
      this.priceExtras = input.priceExtras || [];
      this.coupon = input.coupon || "";
      if (input.duration) this.duration = input.duration;
      this.email = input.email;
      if (input.experienceId) {
        this.experienceId = input.experienceId;
      }
      if (input.time) this.time = input.time;
      if (input.invoiceObject) this.invoiceObject = input.invoiceObject;
      if (input.language) this.language = input.language;
      this.message = input.message;
      this.name = input.name;
      this.phone = input.phone;
      this.privacyBoolean = input.privacyBoolean;
      this.price = input.price || null;
      this.priceLabel = input.priceLabel;
      this.price2Label = input.price2Label;
      this.priceSymbol = input.price_symbol || null;
      this.origin = input.origin || null;
      this.priceCurrency = input.priceCurrency || null;
      if (input.startAt) this.startAt = input.startAt;
      if (input.experience) this.experience = input.experience;
      if (input.pricePerPerson) {
        this.pricePerPerson = input.pricePerPerson;
      }
      if (input.giftId) {
        this.giftId = input.giftId;
      }
      this.total = input.total;
      this.surname = input.surname;
      this.timetable = input.timetable;
      this.visitReason = input.visitReason;
      this.paypalData = input.paypalData;
      this.payAtTheWinery = input.payAtTheWinery;
      this.instantBooking = input.instant_booking;
      this.privacy_profiling = input.privacyProfileAccepted || false;
      this.privacy_marketing =  input.privacyMarketingAccepted || false;
      this.provider = input.provider;
      this.optional_data = input.optionalData;
      this.shippingAddress = input.shippingAddress
    }
    return this;
  }

  deserialize(input: any): Reservation {
    if (input != null) {
      this.aasmState = input.aasm_state || "";
      this.firstName = input.firstname || null;
      this.lastName = input.lastname || null;
      this.adults = input.adults || 0;
      this.priceLabels = input.priceLabels || [];
      this.priceExtras = input.priceExtras || [];
      this.createdAt = UtilitiesFunctions.dateFormatter(input.created_at) || "";
      if (input.duration) this.duration = input.duration;
      this.email = input.email;
      if (input.time) this.time = input.time;
      if (input.id) this.id = input.id;
      if (input.invoiceObject) this.invoiceObject = input.invoiceObject;
      if (input.language) this.language = input.language;
      this.message = input.message;
      this.name = input.name;
      this.phone = input.phone;
      this.privacyBoolean = input.privacyBoolean;
      this.price = input.price || null;
      if (input.price_symbol) this.priceSymbol = input.price_symbol;
      if (input.origin) this.origin = input.origin;
      if (input.price_currency) this.priceCurrency = input.price_currency;
      if (input.experience) this.experience = input.experience;
      this.experienceTypes =
        UtilitiesFunctions.buildCustomTagsList(
          input.experience.tags,
          "exptype"
        ) || [];
      if (input.start_at)
        this.startAt = UtilitiesFunctions.dateFormatter(input.start_at) || "";
      this.surname = input.surname;
      if (input.pricePerPerson) {
        this.pricePerPerson = input.pricePerPerson;
      }
      this.total = input.total_amount;
      this.giftId = input.gift_id;

      if (input.total_amount_symbol) {
        this.totalSymbol = input.total_amount_symbol;
      }
      if (input.total_amount_currency) {
        this.totalCurrency = input.total_amount_currency;
      }
      this.updatedAt = UtilitiesFunctions.dateFormatter(input.updated_at) || "";
      if (input.tags) {
        this.visitReason = UtilitiesFunctions.buildTagsArray(
          input.tags,
          "visit_reasons"
        )[0]
          ? UtilitiesFunctions.buildTagsArray(input.tags, "visit_reasons")[0]
              .name
          : "" || "";
        console.warn("this.visitReason: ", this.visitReason);
      }
      this.payAtTheWinery = input.pay_at_the_winery;
      this.instantBooking = input.instant_booking;
      this.provider = input.provider;
      this.optional_data = input.optional_data;
      this.shippingAddress = input.shippingAddress
    }
    return this;
  }

  requestSerialize(): any {
    return {
      start_at: this.startAt,
      adults: this.adults,
      priceLabels: this.priceLabels,
      priceExtras: this.priceExtras,
      coupon: this.coupon,
      email: this.email,
      firstname: this.name,
      lastname: this.surname,
      phone: this.phone,
      message: this.message,
      time: this.time,
      invoice_data: this.invoiceObject ? this.invoiceObject : null,
      pay_at_the_winery: this.payAtTheWinery,
      paypal_data: this.paypalData
        ? {
          order_id: this.paypalData.orderID,
          authorization_id: this.paypalData.authorizationID
        }
        : null,
      total: this.total != null ? String(this.total) : undefined,
      gift_id: this.giftId,
      privacy_profiling: this.privacy_profiling,
      privacy_marketing:  this.privacy_marketing,
      provider: this.provider,
      payment_intent_id: this.payment_intent_id || null,
      optional_data: this.optional_data,
      shipping_address: this.shippingAddress,
      price_labels: this.priceLabels.filter(e=>e.quantity),
      price_extras: this.priceExtras.filter(e=>e.quantity),
    };
  }
}

export class InvoiceForm implements Serializable<InvoiceForm> {
  address?: string;
  cap?: string;
  city?: string;
  state?: string;
  cf?: string;
  email?: string;
  idCode?: string;
  name?: string;
  phone?: string;
  pi?: string;
  province?: string;
  socialR?: string;
  surname?: string;

  deserialize(input: any): InvoiceForm {
    if (input != null) {
      this.address = input.address;
      this.cap = input.cap;
      this.city = input.city;
      this.state = input.state;
      this.cf = input.cf;
      this.email = input.email;
      this.idCode = input.idCode;
      this.name = input.name;
      this.phone = input.phone;
      this.pi = input.pi;
      this.province = input.province;
      this.socialR = input.socialR;
      this.surname = input.surname;
    }
    return this;
  }

  requestSerialize(): any {
    return {
      firstname: this.name,
      lastname: this.surname,
      company: this.socialR,
      address: this.address,
      zipcode: this.cap,
      city: this.city,
      province: this.province,
      state: this.state,
      taxcode: this.cf,
      vat: this.pi,
      identification_code: this.idCode,
      email: this.email,
      phone: this.phone
    };
  }
}
